import Vue from 'vue'
import 'babel-polyfill'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const state = () => {
  return {
    token: '',
    userInfo: {},
    aside: [],
    cacheData: {},
    recodeRow: {},
    approvalDetail: {},
    opertorInfo: {},
    roleInfo: {},
    importRecodeDetail: {},
    otherPayDetail: {},
    unread: 0,
    invoiceInfo: {},
    taskInfo: {},
    task: {},
    errorNum: {
      errorTime: null,
      num: 3
    },
    random: null,
    forgetRandom: null,
    delayeringMune: [],
    platformInfo: {}
  }
}
const mutations = {
  SET_TOKEN (state, val) {
    state.token = val
  },
  SET_USERINFO (state, val) {
    state.userInfo = val
  },
  SET_ASIDE (state, val) {
    state.aside = val
  },
  SET_CACHEDATA (state, val) {
    state.cacheData = val
  },
  SET_RECODEROW (state, val) {
    state.recodeRow = val
  },
  SET_APPROVALDETAIL (state, val) {
    state.approvalDetail = val
  },
  SET_OPERTORINFO (state, val) {
    state.opertorInfo = val
  },
  SET_ROLEINFO (state, val) {
    state.roleInfo = val
  },
  SET_IMPORTRECODEDETAIL (state, val) {
    state.importRecodeDetail = val
  },
  SET_OTHERPAYDETAIL (state, val) {
    state.otherPayDetail = val
  },
  SET_UNREAD (state, val) {
    state.unread = val
  },
  REDUCE_UNREAD (state, val) {
    state.unread = state.unread - val
  },
  SET_INVOICEINFO (state, val) {
    state.invoiceInfo = val
  },
  SET_TASKINFO (state, val) {
    state.taskInfo = val
  },
  SET_TASK (state, val) {
    state.task = val
  },
  SET_ERROR (state, val) {
    state.errorNum = val
  },
  SET_RANDOM (state, val) {
    state.random = val
  },
  SET_FORGETRANDOM (state, val) {
    state.forgetRandom = val
  },
  SET_DELAYERINGMUNE (state, val) {
    state.delayeringMune = val
  },
  SET_PLANFORMINFO (state, val) {
    state.platformInfo = val
  }
}
const actions = {
  set_token ({ commit }, val) {
    commit('SET_TOKEN', val)
  },
  set_userInfo ({ commit }, val) {
    commit('SET_USERINFO', val)
  },
  set_aside ({ commit }, val) {
    commit('SET_ASIDE', val)
  },
  set_cachedata ({ commit }, val) {
    commit('SET_CACHEDATA', val)
  },
  set_recodeRow ({ commit }, val) {
    commit('SET_RECODEROW', val)
  },
  set_approvaldetail ({ commit }, val) {
    commit('SET_APPROVALDETAIL', val)
  },
  set_opertorInfo ({ commit }, val) {
    commit('SET_OPERTORINFO', val)
  },
  set_roleInfo ({ commit }, val) {
    commit('SET_ROLEINFO', val)
  },
  set_importRecodeDetail ({ commit }, val) {
    commit('SET_IMPORTRECODEDETAIL', val)
  },
  set_otherPayExportDetail ({ commit }, val) {
    commit('SET_OTHERPAYDETAIL', val)
  },
  set_unread ({ commit }, val) {
    commit('SET_UNREAD', val)
  },
  reduce_unread ({ commit }, val) {
    commit('REDUCE_UNREAD', val)
  },
  set_invoiceInfo ({ commit }, val) {
    commit('SET_INVOICEINFO', val)
  },
  set_taskInfo ({ commit }, val) {
    commit('SET_TASKINFO', val)
  },
  set_task ({ commit }, val) {
    commit('SET_TASK', val)
  },
  set_error ({ commit }, val) {
    commit('SET_ERROR', val)
  },
  set_random ({ commit }, val) {
    commit('SET_RANDOM', val)
  },
  set_forgetRandom ({ commit }, val) {
    commit('SET_FORGETRANDOM', val)
  },
  set_delayeringMune ({ commit }, val) {
    commit('SET_DELAYERINGMUNE', val)
  },
  set_platformInfo ({ commit }, val) {
    commit('SET_PLANFORMINFO', val)
  }
}
export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})



// WEBPACK FOOTER //
// ./src/store/store.js